{
  "chart": "Carta Pesakit",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "Demografi",
    "loading": "Memuatkan demografi pesakit...",
    "loadError": "Gagal memuatkan demografi pesakit.",
    "returnToDashboard": "Kembali ke Papan Pemuka",
    "updatedSuccess": "Demografi pesakit telah dikemas kini",
    "updateError": "Gagal mengemas kini demografi pesakit",
    "sections": {
      "personalInformation": "Maklumat Peribadi",
      "identification": "Pengenalan Diri",
      "contactInformation": "Maklumat Hubungan",
      "address": "Alamat",
      "languageAndPreferences": "Bahasa & Pilihan",
      "specialFlags": "Tanda Khas",
      "recordInformation": "Maklumat Rekod"
    },
    "fields": {
      "fullName": "Nama Penuh",
      "alternativeName": "Nama Alternatif",
      "preferredName": "Nama Panggilan",
      "dateOfBirth": "Tarikh Lahir",
      "birthTime": "Masa Lahir",
      "age": "Umur",
      "legalGender": "Jantina Sah",
      "genderIdentity": "Identiti Gender",
      "sexAtBirth": "Jantina Semasa Lahir",
      "race": "Bangsa",
      "ethnicity": "Etnik",
      "nationality": "Kewarganegaraan",
      "mrn": "MRN",
      "nationalIdType": "Jenis Pengenalan",
      "nationalIdNumber": "No. Pengenalan",
      "passportNumber": "Nombor Pasport",
      "passportCountry": "Negara Pasport",
      "primaryPhone": "Telefon Utama",
      "mobilePhone": "Telefon Bimbit",
      "email": "E-mel",
      "preferredContactMethod": "Kaedah Hubungan Pilihan",
      "addressLine1": "Alamat Baris 1",
      "addressLine2": "Alamat Baris 2",
      "city": "Bandar",
      "stateProvince": "Negeri",
      "postalCode": "Poskod",
      "country": "Negara",
      "primaryLanguage": "Bahasa Utama",
      "secondaryLanguage": "Bahasa Kedua",
      "interpreterRequired": "Memerlukan Jurubahasa",
      "vipStatus": "Status VIP",
      "confidentialityLevel": "Tahap Kerahsiaan",
      "medicalTourist": "Pelancong Perubatan",
      "homeCountry": "Negara Asal",
      "status": "Status",
      "deceased": "Meninggal Dunia",
      "created": "Dicipta",
      "lastModified": "Diubah Suai Akhir",
      "passportOnFile": "Pasport Dalam Simpanan",
      "organDonorStatus": "Status Penderma Organ"
    },
    "statusValues": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "deceasedSummary": "Ya ({{date}})",
    "deceasedDateUnknown": "Tarikh tidak diketahui",
    "legalGender": {
      "label": "Jantina Sah",
      "values": {
        "male": "Lelaki",
        "female": "Perempuan",
        "other": "Lain-lain",
        "unknown": "Tidak Diketahui"
      },
      "selectPlaceholder": "Pilih Jantina"
    },
    "sexAtBirth": {
      "label": "Jantina Semasa Lahir",
      "values": {
        "female": "Perempuan",
        "male": "Lelaki",
        "other": "Lain-lain",
        "unknown": "Tidak diketahui"
      },
      "notRecorded": "Tiada rekod"
    },
    "preferredContactMethod": {
      "label": "Kaedah Hubungan Pilihan",
      "values": {
        "phone": "Telefon",
        "mobile": "Bimbit",
        "email": "E-mel",
        "sms": "SMS"
      },
      "notSpecified": "Tidak dinyatakan"
    },
    "validation": {
      "fullNameRequired": "Nama penuh diperlukan",
      "dateOfBirthRequired": "Tarikh lahir diperlukan",
      "countryRequired": "Negara diperlukan",
      "primaryLanguageRequired": "Bahasa utama diperlukan",
      "invalidEmail": "E-mel tidak sah",
      "nationalIdValidationFailed": "Pengesahan nombor pengenalan gagal: {{error}}",
      "invalidBirthTime": "Masa lahir mestilah dalam format HH:MM"
    },
    "organDonor": {
      "notRecorded": "Belum direkodkan",
      "registered": "Berdaftar sebagai penderma",
      "optedOut": "Menarik diri",
      "notRegistered": "Belum berdaftar",
      "unknown": "Tidak diketahui"
    }
  },
  "registration": {
    "title": "Pendaftaran Pesakit",
    "subtitle": "Daftarkan pesakit baharu ke dalam sistem",
    "submit": "Daftarkan Pesakit",
    "submitting": "Mendaftarkan...",
    "checkingDuplicates": "Menyemak pendua...",
    "registerNew": "Daftarkan Pesakit Baharu",
    "registeredSuccess": "Pesakit berjaya didaftarkan",
    "registerError": "Gagal mendaftarkan pesakit",
    "validationNationalIdFailed": "Pengesahan nombor pengenalan gagal: {{error}}",
    "sections": {
      "basicInformation": "Maklumat Asas",
      "identification": "Pengenalan Diri",
      "contactInformation": "Maklumat Hubungan",
      "address": "Alamat",
      "languageAndCommunication": "Bahasa & Komunikasi",
      "additionalInformation": "Maklumat Tambahan"
    },
    "fields": {
      "facility": "Fasiliti pendaftaran"
    },
    "placeholders": {
      "fullName": "Cth. Tan Wei Ming atau 李小明",
      "alternativeName": "Versi rumi jika berkenaan",
      "preferredName": "Nama panggilan yang dipilih pesakit",
      "nationalIdNumberDefault": "Masukkan nombor pengenalan",
      "primaryPhone": "+60 12-345 6789",
      "mobilePhone": "+60 12-345 6789",
      "email": "patient@example.com",
      "facility": "Pilih fasiliti"
    },
    "helperText": {
      "fullName": "Isi nama penuh seperti pada dokumen rasmi",
      "facility": "Fasiliti tempat pesakit ini didaftarkan. Kakitangan di situ akan dapat membuka rekod tersebut."
    },
    "flags": {
      "vipPatient": "Pesakit VIP",
      "medicalTourist": "Pelancong Perubatan"
    },
    "duplicate": {
      "title": "Pesakit Pendua Berpotensi Dijumpai",
      "body": "Pesakit sedia ada berikut sepadan dengan maklumat yang anda masukkan:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "Padanan: {{score}}% ({{reasons}})",
      "useExisting": "Guna Sedia Ada",
      "createNew": "Ini Pesakit Baharu",
      "restricted": {
        "title_one": "{{count}} kemungkinan padanan wujud yang anda tidak boleh lihat",
        "title_other": "{{count}} kemungkinan padanan wujud yang anda tidak boleh lihat",
        "body": "Pesakit ini mungkin sudah mempunyai rekod di fasiliti lain. Hubungi Pengurusan Maklumat Kesihatan sebelum mencipta rekod baharu — butiran disembunyikan kerana rekod itu di luar capaian anda."
      },
      "overrideReasonLabel": "Sebab tetap mendaftar",
      "overrideReasonPlaceholder": "cth. disahkan dengan pesakit bahawa ini orang yang berbeza",
      "overrideReasonHelp": "Direkodkan atas akaun anda. Mendaftar rekod kedua untuk orang yang sama memecahkan carta mereka.",
      "registerAnyway": "Tetap daftar"
    }
  },
  "search": {
    "title": "Cari Pesakit",
    "subtitle": "Cari dan urus rekod pesakit",
    "placeholder": "Cari mengikut nama pesakit, MRN atau ID...",
    "advancedFilters": "Penapis Lanjutan",
    "filters": {
      "mrnPlaceholder": "Cth. P0000000001",
      "fullNamePlaceholder": "Nama pesakit",
      "phonePlaceholder": "Nombor telefon",
      "emailPlaceholder": "Alamat e-mel"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "Nama Penuh",
      "dateOfBirth": "Tarikh Lahir",
      "phone": "Telefon",
      "email": "E-mel",
      "country": "Negara",
      "status": "Status",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "Semua",
      "vipOnly": "VIP Sahaja",
      "nonVipOnly": "Bukan VIP Sahaja"
    },
    "statusFilter": {
      "all": "Semua",
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "countryFilter": {
      "all": "Semua Negara"
    },
    "clearFilters": "Kosongkan Penapis",
    "dateOfBirthAria": "Penapis tarikh lahir",
    "columns": {
      "mrn": "MRN",
      "fullName": "Nama Penuh",
      "dob": "DOB",
      "gender": "Jantina",
      "phone": "Telefon",
      "country": "Negara",
      "status": "Status"
    },
    "results": {
      "searching": "Mencari pesakit...",
      "loadError": "Gagal memuatkan pesakit. Sila cuba lagi.",
      "retry": "Cuba lagi",
      "empty": "Tiada pesakit dijumpai. Sila laraskan kriteria carian.",
      "showing": "Memaparkan {{from}} – {{to}} daripada {{total}} pesakit"
    }
  },
  "myPatients": {
    "title": "Pesakit Saya",
    "subtitle": "Pesakit aktif di bawah jagaan anda",
    "searchPlaceholder": "Tapis mengikut nama atau MRN...",
    "columns": {
      "mrn": "MRN",
      "patient": "Nama Penuh",
      "dob": "DOB",
      "sex": "Jantina",
      "class": "Kelas",
      "relationship": "Hubungan",
      "admitted": "Tarikh Masuk"
    },
    "kind": {
      "attending": "Doktor Merawat",
      "careTeam": "Pasukan jagaan",
      "referral": "Rujukan",
      "coverage": "Liputan"
    },
    "restrictedBadge": "Terhad",
    "empty": {
      "title": "Tiada pesakit dalam panel anda",
      "body": "Pesakit yang anda rawat, liput, atau terima melalui rujukan akan dipaparkan di sini.",
      "censusAction": "Buka papan katil"
    },
    "results": {
      "searching": "Memuatkan pesakit anda...",
      "loadError": "Gagal memuatkan pesakit anda. Sila cuba lagi.",
      "retry": "Cuba lagi",
      "showing": "Memaparkan {{from}} – {{to}} daripada {{total}} pesakit"
    }
  },
  "encounters": {
    "title": "Kunjungan",
    "create": "Cipta Kunjungan",
    "filters": "Penapis",
    "filterLabels": {
      "status": "Status",
      "class": "Kelas",
      "fromDate": "Dari Tarikh",
      "toDate": "Hingga Tarikh"
    },
    "filterPlaceholders": {
      "allStatuses": "Semua Status",
      "allClasses": "Semua Kelas"
    },
    "clearFilters": "Kosongkan Penapis",
    "fromDateAria": "Dari Tarikh",
    "toDateAria": "Hingga Tarikh",
    "columns": {
      "encounterNumber": "No. Kunjungan",
      "class": "Kelas",
      "status": "Status",
      "admitDate": "Tarikh Kemasukan",
      "dischargeDate": "Tarikh Discaj",
      "location": "Lokasi",
      "chiefComplaint": "Keluhan Utama"
    },
    "locationLabel": "Lokasi #{{id}}",
    "loading": "Memuatkan kunjungan...",
    "loadError": "Gagal memuatkan kunjungan.",
    "empty": "Tiada kunjungan untuk pesakit ini.",
    "showing": "Memaparkan {{from}} – {{to}} daripada {{total}}"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "Jenis Pengenalan",
      "none": "Tiada",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "Kad Pengenalan Thai"
      },
      "country": {
        "nric": "Singapura",
        "hkid": "Hong Kong",
        "myKad": "Malaysia",
        "aadhaar": "India",
        "ktp": "Indonesia",
        "myNumber": "Jepun",
        "thaiNationalId": "Thailand"
      },
      "placeholderByType": {
        "nric": "Cth. S1234567D",
        "myKad": "Cth. 850101-14-5678",
        "hkid": "Cth. A123456(3)",
        "aadhaar": "Cth. 2341 2341 2346",
        "thaiNationalId": "Cth. 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "Aksara semakan tidak sepadan dengan jenis pengenalan ini. Semak nombor dengan dokumen pengenalan pesakit.",
      "unavailable": "Nombor pengenalan ini tidak dapat disemak. Semak nombor dengan dokumen pengenalan pesakit.",
      "acknowledge": "Saya telah menyemak nombor ini dengan dokumen pengenalan",
      "acknowledgeRequired": "Semak nombor pengenalan dengan dokumen pengenalan dan sahkan sebelum menyimpan."
    }
  },
  "country": {
    "values": {
      "sg": "Singapura",
      "my": "Malaysia",
      "th": "Thailand",
      "id": "Indonesia",
      "ph": "Filipina",
      "vn": "Vietnam",
      "hk": "Hong Kong",
      "tw": "Taiwan",
      "jp": "Jepun",
      "kr": "Korea Selatan",
      "cn": "China",
      "in": "India",
      "au": "Australia",
      "nz": "New Zealand"
    }
  },
  "language": {
    "values": {
      "en": "Inggeris",
      "zh": "Cina (Mandarin)",
      "ms": "Melayu",
      "ta": "Tamil",
      "th": "Thai",
      "id": "Indonesia",
      "vi": "Vietnam",
      "ja": "Jepun",
      "ko": "Korea",
      "hi": "Hindi"
    }
  },
  "contact": {
    "addTitle": "Tambah Kenalan",
    "editTitle": "Edit Kenalan",
    "name": "Nama",
    "relationship": {
      "label": "Hubungan",
      "selectPlaceholder": "Pilih...",
      "values": {
        "spouse": "Pasangan",
        "parent": "Ibu Bapa",
        "child": "Anak",
        "sibling": "Adik-beradik",
        "guardian": "Penjaga",
        "friend": "Rakan",
        "other": "Lain-lain"
      }
    },
    "phone": "Telefon",
    "email": "E-mel",
    "emergencyContact": "Kenalan kecemasan",
    "validation": {
      "nameRequired": "Nama kenalan diperlukan",
      "relationshipRequired": "Hubungan diperlukan",
      "phoneRequired": "Nombor telefon diperlukan",
      "invalidEmail": "E-mel tidak sah"
    },
    "savedSuccess": "Kenalan berjaya ditambah",
    "saveError": "Gagal menambah kenalan"
  },
  "immunization": {
    "addTitle": "Tambah Imunisasi",
    "vaccineName": "Nama Vaksin",
    "vaccineNamePlaceholder": "cth. Influenza, COVID-19 (Pfizer), Hepatitis B",
    "vaccineCode": "Kod Vaksin (CVX)",
    "vaccineCodePlaceholder": "cth. 141",
    "administeredDate": "Tarikh Pemberian",
    "lotNumber": "Nombor Lot",
    "lotNumberPlaceholder": "cth. AB1234",
    "site": {
      "label": "Lokasi",
      "selectPlaceholder": "Pilih lokasi",
      "values": {
        "leftDeltoid": "Deltoid Kiri",
        "rightDeltoid": "Deltoid Kanan",
        "leftThigh": "Peha Kiri",
        "rightThigh": "Peha Kanan",
        "leftGluteal": "Punggung Kiri",
        "rightGluteal": "Punggung Kanan",
        "other": "Lain-lain"
      }
    },
    "route": {
      "label": "Laluan",
      "selectPlaceholder": "Pilih laluan",
      "values": {
        "intramuscular": "Intramuskular (IM)",
        "subcutaneous": "Subkutaneus (SC)",
        "intradermal": "Intradermal (ID)",
        "oral": "Oral",
        "intranasal": "Intranasal"
      }
    },
    "doseAmount": "Dos",
    "doseAmountPlaceholder": "cth. 0.5 mL",
    "administeredBy": "Diberikan oleh",
    "administeredByPlaceholder": "Nama atau ID kakitangan",
    "nextDueDate": "Tarikh Pemberian Seterusnya",
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "validation": {
      "vaccineNameRequired": "Nama vaksin diperlukan",
      "administeredDateRequired": "Tarikh pemberian diperlukan"
    },
    "savedSuccess": "Rekod imunisasi ditambah",
    "saveError": "Gagal menambah rekod imunisasi"
  },
  "insurance": {
    "addTitle": "Tambah Pelan Insurans",
    "submitLabel": "Tambah Insurans",
    "payerName": "Nama Pembayar",
    "payerNamePlaceholder": "cth. AIA Singapore",
    "payerId": "ID Pembayar",
    "payerIdPlaceholder": "Pengenal pembayar",
    "planName": "Nama Pelan",
    "planNamePlaceholder": "cth. HealthShield Gold Max",
    "planType": {
      "label": "Jenis Pelan",
      "selectPlaceholder": "Pilih jenis",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "Kerajaan",
        "private": "Swasta",
        "corporate": "Korporat",
        "other": "Lain-lain"
      }
    },
    "memberId": "ID Ahli",
    "memberIdPlaceholder": "Nombor ID ahli",
    "policyNumber": "Nombor Polisi",
    "policyNumberPlaceholder": "Masukkan nombor polisi",
    "groupNumber": "Nombor Kumpulan",
    "groupNumberPlaceholder": "Nombor kumpulan",
    "subscriberName": "Nama Pelanggan",
    "subscriberNamePlaceholder": "Jika berbeza daripada pesakit",
    "subscriberRelationship": {
      "label": "Hubungan dengan Pelanggan",
      "values": {
        "self": "Diri sendiri",
        "spouse": "Pasangan",
        "child": "Anak",
        "parent": "Ibu Bapa",
        "other": "Lain-lain"
      }
    },
    "priority": {
      "label": "Keutamaan",
      "values": {
        "primary": "Primer",
        "secondary": "Sekunder",
        "tertiary": "Tertier"
      }
    },
    "effectiveDate": "Tarikh Kuat Kuasa",
    "terminationDate": "Tarikh Tamat",
    "copayAmount": "Bayaran Bersama ($)",
    "coinsurancePercent": "Koinsurans (%)",
    "deductibleAmount": "Bayaran Sendiri ($)",
    "outOfPocketMax": "Had Bayaran Sendiri ($)",
    "preAuthRequired": "Perlu Pra-keizinan",
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "validation": {
      "payerNameRequired": "Nama pembayar diperlukan",
      "planNameRequired": "Nama pelan diperlukan",
      "memberIdRequired": "ID ahli diperlukan",
      "effectiveDateRequired": "Tarikh kuat kuasa diperlukan"
    },
    "savedSuccess": "Pelan insurans ditambah",
    "saveError": "Gagal menambah pelan insurans"
  },
  "problem": {
    "addTitle": "Tambah Masalah",
    "problemName": "Nama Masalah",
    "problemNamePlaceholder": "cth. Diabetes Mellitus Jenis 2",
    "icdCode": "Kod ICD-10",
    "icdSearchPlaceholder": "Cari kod atau penerangan ICD-10...",
    "onsetDate": "Tarikh Mula",
    "severity": {
      "label": "Keterukan",
      "values": {
        "mild": "Ringan",
        "moderate": "Sederhana",
        "severe": "Teruk"
      }
    },
    "notes": "Catatan",
    "notesPlaceholder": "Catatan klinikal tambahan...",
    "validation": {
      "problemNameRequired": "Nama masalah diperlukan"
    },
    "savedSuccess": "Masalah ditambah ke senarai masalah",
    "saveError": "Gagal menambah masalah"
  },
  "accounts": {
    "pageTitle": "Akaun Pesakit",
    "backToDashboard": "Papan Pemuka",
    "searchPatientLabel": "Cari Pesakit",
    "searchPlaceholder": "Cari mengikut nama atau MRN...",
    "searching": "Mencari...",
    "noPatientsFound": "Pesakit tidak ditemui",
    "loadingAccount": "Memuatkan akaun...",
    "mrnLabel": "MRN",
    "generateStatement": "Jana Penyata",
    "statementComingSoon": "Penjanaan penyata akan datang",
    "paymentPlan": "Pelan Pembayaran",
    "paymentPlanComingSoon": "Tetapan pelan pembayaran akan datang",
    "totalCharges": "Jumlah Caj",
    "totalPayments": "Jumlah Bayaran",
    "adjustments": "Pelarasan",
    "outstandingBalance": "Baki Tertunggak",
    "transactionHistory": "Sejarah Transaksi",
    "columns": {
      "date": "Tarikh",
      "type": "Jenis",
      "description": "Penerangan",
      "amount": "Jumlah",
      "balance": "Baki"
    },
    "transactionType": {
      "label": "Jenis",
      "values": {
        "charge": "Caj",
        "payment": "Bayaran",
        "adjustment": "Pelarasan"
      }
    },
    "loadingTransactions": "Memuatkan transaksi...",
    "noTransactionsFound": "Tiada transaksi ditemui",
    "emptyState": "Cari pesakit untuk melihat akaun mereka"
  },
  "proxies": {
    "title": "Wakil Diberi Kuasa",
    "description": "Penjaga, wali, dan wakil sah yang dibenarkan untuk mengakses data portal pesakit ini. Entri yang dibatalkan disimpan untuk audit.",
    "addProxy": "Tambah Wakil",
    "newRelationshipHeading": "Hubungan wakil baharu",
    "proxyUserId": "ID pengguna wakil",
    "proxyUserIdPlaceholder": "ID Pengguna (daripada Admin → Pengguna)",
    "proxyUserIdHelper": "Cari di Admin → Pengguna. Komponen pemilih pengguna akan tersedia pada kemas kini berikutnya.",
    "relationship": {
      "label": "Hubungan",
      "values": {
        "parent": "Ibu Bapa",
        "legalGuardian": "Penjaga Sah",
        "spousePartner": "Pasangan / Teman",
        "adultChild": "Anak Dewasa",
        "powerOfAttorney": "Surat Kuasa Wakil",
        "healthcareAgent": "Wakil Penjagaan Kesihatan"
      }
    },
    "accessLevel": {
      "label": "Tahap akses",
      "values": {
        "full": "Penuh",
        "limited": "Terhad",
        "emergency": "Kecemasan"
      },
      "descriptions": {
        "full": "Semua data portal — janji temu, keputusan, mesej, borang.",
        "limited": "Janji temu dan mesej sahaja (biasa untuk remaja).",
        "emergency": "Setara break-glass untuk wakil penjagaan kesihatan apabila pesakit hilang upaya."
      }
    },
    "startDate": "Tarikh mula",
    "endDate": "Tarikh tamat",
    "startDateAria": "Tarikh mula kuat kuasa",
    "endDateAria": "Tarikh tamat kuat kuasa",
    "grantAccess": "Berikan akses wakil",
    "userIdRequired": "ID pengguna wakil diperlukan",
    "createdSuccess": "Hubungan wakil telah dicipta",
    "duplicateError": "Orang ini sudah menjadi wakil dengan hubungan tersebut",
    "invalidDataError": "Data wakil tidak sah",
    "createError": "Gagal mencipta wakil",
    "revokedSuccess": "Akses wakil telah dibatalkan",
    "revokeError": "Gagal membatalkan wakil",
    "emptyState": "Tiada wakil dikonfigurasi. Gunakan butang di atas untuk memberikan akses kepada penjaga, wali atau wakil penjagaan kesihatan.",
    "sections": {
      "active": "Aktif ({{count}})",
      "plannedInactive": "Dirancang / Tidak Aktif ({{count}})",
      "revoked": "Dibatalkan ({{count}})"
    },
    "userIdFallback": "Pengguna #{{id}}",
    "noEndDate": "(tiada tarikh tamat)",
    "revokedOn": "Dibatalkan {{date}}",
    "revokeTitle": "Batalkan akses wakil",
    "confirmRevokeTitle": "Batalkan akses wakil?",
    "confirmRevokeBody": "{{name}} akan kehilangan akses kepada data portal pesakit ini serta-merta. Rekod kekal dalam jejak audit.",
    "confirmRevokeLabel": "Batalkan akses"
  },
  "merge": {
    "title": "Gabung Pesakit",
    "description": "Gabungkan rekod pesakit yang berganda. Pesakit sumber akan dinyahaktifkan dan semua data klinikal akan dipindahkan ke pesakit sasaran (yang dikekalkan).",
    "sourceLabel": "Pesakit Sumber (akan dinyahaktifkan)",
    "targetLabel": "Pesakit Sasaran (rekod yang dikekalkan)",
    "clearSelection": "Kosongkan pilihan",
    "searchPlaceholder": "Cari mengikut nama, MRN, atau telefon...",
    "fields": {
      "mrn": "MRN",
      "dob": "Tarikh Lahir",
      "gender": "Jantina",
      "country": "Negara",
      "phone": "Telefon",
      "email": "E-mel"
    },
    "counts": {
      "encounters": "Lawatan: {{count}}",
      "allergies": "Alahan: {{count}}",
      "problems": "Masalah: {{count}}"
    },
    "samePatientWarning": "Sumber dan sasaran mestilah pesakit yang berbeza.",
    "comparisonTitle": "Perbandingan Demografi",
    "comparisonSubtitle": "Perbezaan diserlahkan dalam warna amber.",
    "columns": {
      "field": "Medan",
      "source": "Sumber ({{mrn}})",
      "target": "Sasaran ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "Nama Penuh",
      "mrn": "MRN",
      "dateOfBirth": "Tarikh Lahir",
      "gender": "Jantina",
      "phone": "Telefon",
      "email": "E-mel",
      "country": "Negara",
      "nationalId": "ID Negara"
    },
    "reasonLabel": "Sebab Penggabungan",
    "reasonPlaceholder": "Sebab menggabungkan rekod ini (diperlukan)",
    "notesLabel": "Catatan (pilihan)",
    "notesPlaceholder": "Catatan tambahan tentang penggabungan ini",
    "mergeButton": "Gabung Pesakit",
    "mergeSuccess": "Pesakit berjaya digabung",
    "mergeError": "Gagal menggabung pesakit",
    "successHeading": "Penggabungan berjaya diselesaikan.",
    "successBodyPrefix": "Pesakit {{mrn}} telah dinyahaktifkan. Semua data klinikal telah dipindahkan ke ",
    "successBodySuffix": ".",
    "confirmTitle": "Sahkan Penggabungan Pesakit",
    "confirmBodyPrefix": "Tindakan ini ",
    "confirmBodyEmphasis": "TIDAK BOLEH dibatalkan",
    "confirmBodySuffix": ". Pesakit {{sourceMrn}} ({{sourceName}}) akan dinyahaktifkan dan semua data klinikal akan dipindahkan ke Pesakit {{targetMrn}} ({{targetName}}).",
    "confirmButton": "Ya, Gabung Pesakit",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "Rekod pesakit tidak dapat dimuatkan."
  },
  "allergy": {
    "addTitle": "Tambah Alahan",
    "editTitle": "Sunting Alahan",
    "allergen": "Alergen",
    "allergenPlaceholder": "Cth. Penisilin, Kacang Tanah",
    "type": "Jenis",
    "typeOptions": {
      "drug": "Ubat",
      "food": "Makanan",
      "environmental": "Persekitaran"
    },
    "severityLabel": "Tahap Keterukan",
    "severity": {
      "mild": "Ringan",
      "moderate": "Sederhana",
      "severe": "Teruk",
      "lifeThreatening": "Mengancam Nyawa"
    },
    "reaction": "Reaksi",
    "reactionPlaceholder": "Cth. Ruam Gatal, Anafilaksis, Loya",
    "reactionOptions": {
      "rash": "Ruam",
      "hives": "Ruam Gatal",
      "anaphylaxis": "Anafilaksis",
      "swelling": "Bengkak",
      "itching": "Gatal",
      "other": "Lain-lain"
    },
    "onsetDate": "Tarikh Mula",
    "notes": "Catatan",
    "notesPlaceholder": "Catatan tambahan...",
    "verifiedBy": "Disahkan Oleh",
    "noKnownAllergies": "Tiada Alahan Diketahui",
    "savedSuccess": "Alahan berjaya ditambah",
    "saveError": "Gagal menambah alahan",
    "deletedSuccess": "Alahan dialih keluar"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "Skala Braden (Risiko Kecederaan Tekanan)",
      "footer": "Julat keseluruhan: 6-23. Skor yang lebih rendah menunjukkan risiko kecederaan tekanan yang lebih tinggi.",
      "scoreFormat": "Skor: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "Risiko Sangat Tinggi",
        "high": "Risiko Tinggi",
        "moderate": "Risiko Sederhana",
        "mild": "Risiko Ringan",
        "none": "Tiada Risiko"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. Persepsi Deria",
          "options": {
            "1": "{{n}} - Terhad sepenuhnya",
            "2": "{{n}} - Sangat terhad",
            "3": "{{n}} - Sedikit terhad",
            "4": "{{n}} - Tiada kerosakan"
          }
        },
        "moisture": {
          "label": "{{n}}. Kelembapan",
          "options": {
            "1": "{{n}} - Sentiasa lembap",
            "2": "{{n}} - Sangat lembap",
            "3": "{{n}} - Kadang-kadang lembap",
            "4": "{{n}} - Jarang lembap"
          }
        },
        "activity": {
          "label": "{{n}}. Aktiviti",
          "options": {
            "1": "{{n}} - Terlantar",
            "2": "{{n}} - Terhad pada kerusi",
            "3": "{{n}} - Kadang berjalan",
            "4": "{{n}} - Kerap berjalan"
          }
        },
        "mobility": {
          "label": "{{n}}. Mobiliti",
          "options": {
            "1": "{{n}} - Tidak boleh bergerak",
            "2": "{{n}} - Sangat terhad",
            "3": "{{n}} - Sedikit terhad",
            "4": "{{n}} - Tiada had"
          }
        },
        "nutrition": {
          "label": "{{n}}. Pemakanan",
          "options": {
            "1": "{{n}} - Sangat lemah",
            "2": "{{n}} - Mungkin tidak cukup",
            "3": "{{n}} - Mencukupi",
            "4": "{{n}} - Cemerlang"
          }
        },
        "frictionShear": {
          "label": "{{n}}. Geseran & Ricih",
          "options": {
            "1": "{{n}} - Bermasalah",
            "2": "{{n}} - Berpotensi bermasalah",
            "3": "{{n}} - Tiada masalah jelas"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "Skala Jatuh Morse",
      "scoreFormat": "Skor: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. Sejarah Jatuh",
          "options": {
            "0": "Tidak ({{score}})",
            "25": "Ya ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. Diagnosis Sekunder",
          "options": {
            "0": "Tidak ({{score}})",
            "15": "Ya ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. Alat Bantuan Berjalan",
          "options": {
            "0": "Tiada / Rehat di katil / Bantuan jururawat ({{score}})",
            "15": "Tongkat ketiak / Tongkat / Alat penyokong berjalan ({{score}})",
            "30": "Berpaut pada perabot ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. Tiub IV / Heparin Lock",
          "options": {
            "0": "Tiada ({{score}})",
            "20": "Ada ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. Cara Berjalan",
          "options": {
            "0": "Normal / Rehat di katil / Kerusi roda ({{score}})",
            "10": "Lemah ({{score}})",
            "20": "Terjejas ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. Status Mental",
          "options": {
            "0": "Sedar akan keupayaan diri ({{score}})",
            "15": "Melebih-lebihkan / Lupa batasan ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "Intervensi Risiko Tinggi: Laksanakan pencegahan jatuh standard. Pasang gelang risiko jatuh pada pesakit. Pasang tanda risiko jatuh di sisi katil. Didik pesakit dan keluarga. Pastikan katil dalam kedudukan terendah dengan brek terkunci. Pastikan butang panggilan dalam jangkauan. Kasut anti gelincir. Jadual ke tandas. Pertimbangkan penyeliaan 1:1 jika perlu.",
        "moderate": "Intervensi Risiko Sederhana: Laksanakan pencegahan jatuh standard. Pasang gelang risiko jatuh pada pesakit. Didik pesakit dan keluarga. Pastikan katil dalam kedudukan terendah dengan brek terkunci. Pastikan butang panggilan dalam jangkauan. Kasut anti gelincir.",
        "low": "Intervensi Risiko Rendah: Penjagaan kejururawatan asas yang baik. Didik pesakit tentang pergerakan selamat. Orientasi persekitaran dan penggunaan butang panggilan."
      }
    }
  },
  "banner": {
    "label": "Maklumat pesakit",
    "vip": "VIP",
    "vipTitle": "Pesakit VIP",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "th",
    "sex": "Jantina",
    "codeStatusAria": "Status kod: {{status}}",
    "isolationAria": "Pengasingan: {{status}}",
    "isolation": {
      "contact": "Sentuhan",
      "droplet": "Titisan",
      "airborne": "Udara",
      "none": "Tiada"
    },
    "fallRiskAria": "Risiko jatuh: {{level}}",
    "fallRisk": {
      "label": "Risiko Jatuh",
      "low": "Rendah",
      "moderate": "Sederhana",
      "high": "Tinggi"
    },
    "pressureInjuryRisk": "Risiko Kecederaan Tekanan",
    "pressureInjuryRiskAria": "Risiko kecederaan tekanan: {{level}}",
    "interpreter": "Jurubahasa",
    "interpreterRequired": "Memerlukan jurubahasa — {{language}}",
    "languageNotSpecified": "bahasa tidak dinyatakan",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "Alahan",
    "moreAllergies_one": "+{{count}} lagi",
    "moreAllergies_other": "+{{count}} lagi",
    "nkda": "NKDA",
    "allergiesUnknown": "Alergi tidak diketahui — gagal dimuat"
  },
  "chartFrame": {
    "navAriaLabel": "Navigasi rekod perubatan pesakit",
    "tabs": {
      "summary": "Ringkasan",
      "encounters": "Kunjungan",
      "orders": "Arahan",
      "results": "Keputusan",
      "medications": "Ubat",
      "notes": "Nota",
      "problems": "Senarai Masalah",
      "allergies": "Alahan",
      "immunizations": "Imunisasi",
      "intakeOutput": "Pengambilan/Pengeluaran",
      "carePlans": "Pelan Penjagaan",
      "referrals": "Rujukan",
      "familyHistory": "Sejarah Keluarga",
      "socialHistory": "Sejarah Sosial",
      "surgicalHistory": "Sejarah Pembedahan",
      "advanceDirectives": "Arahan Awal",
      "insurance": "Insurans",
      "contacts": "Hubungan",
      "proxies": "Wakil",
      "identifiers": "Pengecam",
      "addresses": "Alamat",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "Peranti",
      "ccdaImports": "Import C-CDA"
    },
    "groups": {
      "clinical": "Klinikal",
      "history": "Sejarah",
      "admin": "Pentadbiran"
    },
    "breakGlass": {
      "auditBanner": "AKSES KECEMASAN — Semua aktiviti sedang diaudit. Akses akan tamat dalam 15 minit.",
      "dialogTitle": "Rekod Pesakit Terhad",
      "dialogSubtitle": "Memerlukan akses kecemasan",
      "dialogBody": "Rekod pesakit ini dihadkan. Anda mesti memberikan justifikasi untuk mengaksesnya. Semua akses kecemasan direkodkan dan diaudit.",
      "justificationLabel": "Justifikasi",
      "justificationPlaceholder": "Masukkan justifikasi klinikal untuk mengakses rekod terhad ini...",
      "justificationRequired": "Justifikasi diperlukan untuk akses kecemasan.",
      "requestError": "Permintaan akses kecemasan gagal. Sila cuba lagi atau hubungi pentadbir.",
      "submitButton": "Akses Rekod",
      "submitting": "Memohon...",
      "passwordLabel": "Sahkan kata laluan anda",
      "passwordPlaceholder": "Masukkan semula kata laluan anda",
      "passwordRequired": "Kata laluan anda diperlukan untuk akses kecemasan.",
      "passwordIncorrect": "Kata laluan salah. Sila cuba lagi.",
      "passwordHelp": "Mengesahkan bahawa anda yang berada di stesen kerja ini.",
      "totpLabel": "Kod pengesah",
      "totpPlaceholder": "Kod 6 digit",
      "totpRequired": "Kod pengesah anda diperlukan untuk akses kecemasan.",
      "totpIncorrect": "Kod salah. Sila cuba lagi.",
      "totpHelp": "Mengesahkan bahawa anda yang berada di stesen kerja ini.",
      "totpEnrollHint": "Tiada pengesah didaftarkan — daftarkan satu dalam Profil Saya untuk menggunakan akses kecemasan."
    },
    "invalidId": {
      "title": "ID Pesakit Tidak Sah",
      "body": "ID pesakit yang diberikan tidak sah.",
      "action": "Cari Pesakit"
    },
    "notFound": {
      "title": "Pesakit Tidak Dijumpai",
      "body": "Tidak dapat memuatkan data pesakit. Pesakit mungkin tidak wujud atau anda tidak mempunyai akses.",
      "action": "Cari Pesakit"
    },
    "loadError": {
      "title": "Gagal Memuatkan Carta Pesakit",
      "body": "Carta tidak dapat dimuatkan. Sila cuba lagi.",
      "action": "Cuba lagi"
    }
  },
  "address": {
    "title": "Alamat",
    "addAddress": "Tambah Alamat",
    "newTitle": "Alamat Baharu",
    "editTitle": "Sunting Alamat",
    "loading": "Memuatkan alamat...",
    "loadError": "Gagal memuatkan maklumat alamat.",
    "empty": "Belum ada alamat.",
    "addressType": {
      "label": "Jenis",
      "values": {
        "home": "Rumah",
        "work": "Tempat Kerja",
        "temporary": "Sementara",
        "billing": "Bil"
      }
    },
    "fields": {
      "addressLine1": "Alamat Baris 1",
      "addressLine2": "Alamat Baris 2",
      "addressLine3": "Alamat Baris 3",
      "district": "Daerah",
      "city": "Bandar",
      "stateProvince": "Negeri",
      "postalCode": "Poskod",
      "country": "Negara"
    },
    "placeholders": {
      "addressLine1": "Alamat jalan",
      "addressLine2": "Apt, unit, tingkat",
      "addressLine3": "Bangunan, blok",
      "district": "Daerah/mukim",
      "postalCode": "cth: 50300",
      "country": "cth: MY"
    },
    "primaryBadge": "Utama",
    "setPrimary": "Tetapkan sebagai alamat utama",
    "primaryHelper": "(alamat lain akan dinyahtetapkan sebagai utama)",
    "fromLabel": "Dari: {{date}}",
    "toLabel": "Hingga: {{date}}",
    "save": "Simpan",
    "update": "Kemas Kini",
    "cancel": "Batal",
    "editTooltip": "Sunting alamat",
    "removeTooltip": "Buang alamat",
    "addedSuccess": "Alamat ditambah",
    "addError": "Gagal menambah alamat",
    "updatedSuccess": "Alamat dikemas kini",
    "updateError": "Gagal mengemas kini alamat",
    "removedSuccess": "Alamat dibuang",
    "removeError": "Gagal membuang alamat",
    "requiredError": "Alamat baris 1 dan negara diperlukan",
    "confirmRemoveTitle": "Buang Alamat",
    "confirmRemoveMessage": "Adakah anda pasti mahu membuang alamat {{type}} ini?",
    "confirmRemoveLabel": "Buang"
  },
  "allergies": {
    "pageTitle": "Alahan",
    "addAllergy": "Tambah Alahan",
    "loading": "Memuatkan alahan...",
    "loadError": "Gagal memuatkan maklumat alahan.",
    "nka": {
      "title": "Tiada Alahan Diketahui (NKA)",
      "body": "Tiada alahan direkodkan untuk pesakit ini."
    },
    "sections": {
      "active": "Alahan Aktif ({{count}})",
      "inactive": "Alahan Tidak Aktif ({{count}})"
    },
    "fields": {
      "reaction": "Reaksi",
      "severity": "Tahap Keterukan",
      "onset": "Permulaan",
      "recorded": "Tarikh Direkod"
    },
    "inactiveSummary": "Reaksi: {{reaction}} | Tahap Keterukan: {{severity}}",
    "deactivate": "Nyahaktifkan",
    "deactivateTooltip": "Nyahaktifkan alahan",
    "deleteTooltip": "Padam alahan",
    "deactivatedSuccess": "Alahan dinyahaktifkan",
    "deactivateError": "Gagal menyahaktifkan alahan",
    "removedSuccess": "Alahan dibuang",
    "removeError": "Gagal membuang alahan",
    "confirmDeactivateTitle": "Sahkan Penyahaktifan",
    "confirmDeactivateMessage": "Adakah anda pasti mahu menyahaktifkan \"{{name}}\"?",
    "confirmDeleteTitle": "Sahkan Pemadaman",
    "confirmDeleteMessage": "Adakah anda pasti mahu memadam \"{{name}}\" secara kekal?",
    "confirmLabel": "Sahkan"
  },
  "problems": {
    "pageTitle": "Senarai Masalah",
    "addProblem": "Tambah Masalah",
    "loading": "Memuatkan senarai masalah...",
    "loadError": "Gagal memuatkan senarai masalah.",
    "tabs": {
      "active": "Aktif ({{count}})",
      "resolvedInactive": "Diselesaikan / Tidak Aktif ({{count}})"
    },
    "sortByLabel": "Susun mengikut:",
    "sortBy": {
      "onsetDate": "Tarikh Permulaan",
      "severity": "Tahap Keterukan"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Aktif",
        "resolved": "Diselesaikan",
        "inactive": "Tidak Aktif"
      }
    },
    "empty": {
      "active": "Tiada masalah aktif direkodkan.",
      "resolved": "Tiada masalah diselesaikan atau tidak aktif."
    },
    "fields": {
      "onset": "Permulaan",
      "resolved": "Selesai"
    },
    "resolveButton": "Selesaikan",
    "reactivateButton": "Aktifkan Semula",
    "resolveTooltip": "Tandakan sebagai diselesaikan",
    "reactivateTooltip": "Aktifkan semula",
    "statusUpdatedSuccess": "Status masalah dikemas kini",
    "statusUpdateError": "Gagal mengemas kini status masalah"
  },
  "immunizations": {
    "pageTitle": "Imunisasi",
    "addImmunization": "Tambah Imunisasi",
    "loading": "Memuatkan rekod imunisasi...",
    "loadError": "Gagal memuatkan rekod imunisasi.",
    "empty": "Tiada rekod imunisasi dijumpai.",
    "dueOverdue": "Imunisasi Tertangguh / Tertunggak ({{count}})",
    "upcoming": "Imunisasi Akan Datang ({{count}})",
    "dueLabel": "Tarikh: {{date}}",
    "fromDateLabel": "Dari Tarikh",
    "toDateLabel": "Hingga Tarikh",
    "fromDateAria": "Tarikh mula imunisasi",
    "toDateAria": "Tarikh akhir imunisasi",
    "clearFilters": "Kosongkan",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "Vaksin",
      "date": "Tarikh",
      "lotNumber": "No. Lot",
      "site": "Lokasi",
      "administeredBy": "Diberi Oleh",
      "nextDue": "Seterusnya",
      "status": "Status"
    },
    "dueStatus": {
      "label": "Status",
      "values": {
        "overdue": "Tertunggak",
        "dueToday": "Hari Ini Tertangguh",
        "upcoming": "Akan Datang"
      }
    }
  },
  "contacts": {
    "pageTitle": "Kenalan",
    "addContact": "Tambah Kenalan",
    "loading": "Memuatkan kenalan...",
    "loadError": "Gagal memuatkan maklumat kenalan.",
    "empty": "Belum ada kenalan.",
    "emergencyBadge": "Kecemasan",
    "sections": {
      "emergency": "Kenalan Kecemasan ({{count}})",
      "other": "Kenalan Lain ({{count}})"
    },
    "editTooltip": "Sunting kenalan",
    "deleteTooltip": "Padam kenalan",
    "deletedSuccess": "Kenalan dipadam",
    "deleteError": "Gagal memadam kenalan",
    "confirmDeleteTitle": "Padam Kenalan",
    "confirmDeleteMessage": "Adakah anda pasti mahu memadam \"{{name}}\"?",
    "confirmDeleteLabel": "Padam"
  },
  "insurances": {
    "pageTitle": "Insurans",
    "addInsurance": "Tambah Insurans",
    "loading": "Memuatkan maklumat insurans...",
    "loadError": "Gagal memuatkan maklumat insurans.",
    "empty": {
      "title": "Tiada Pelan Insurans",
      "body": "Belum ada pelan insurans yang direkodkan untuk pesakit ini."
    },
    "sections": {
      "active": "Pelan Aktif ({{count}})",
      "inactive": "Pelan Tidak Aktif ({{count}})"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Aktif",
        "inactive": "Tidak Aktif",
        "pendingVerification": "Menunggu Pengesahan"
      }
    },
    "fields": {
      "memberId": "ID Ahli",
      "groupNumber": "Nombor Kumpulan",
      "effectiveDate": "Tarikh Berkuat Kuasa",
      "terminationDate": "Tarikh Tamat",
      "copay": "Bayaran Bersama",
      "coinsurance": "Bayaran Insurans Bersama",
      "deductible": "Boleh Tolak",
      "subscriber": "Pelanggan"
    },
    "preAuthBadge": "Memerlukan Kebenaran Awal",
    "lastVerifiedLabel": "Disahkan terakhir: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "Sahkan",
    "verifyTooltip": "Sahkan kelayakan",
    "editButton": "Sunting",
    "verifySuccess": "Pengesahan kelayakan dimulakan",
    "verifyError": "Pengesahan kelayakan gagal"
  },
  "identifiersTab": {
    "pageTitle": "Pengecam",
    "addIdentifier": "Tambah Pengecam",
    "loading": "Memuatkan pengecam...",
    "loadError": "Gagal memuatkan maklumat pengecam.",
    "empty": "Belum ada pengecam.",
    "newTitle": "Pengecam Baharu",
    "type": {
      "label": "Jenis",
      "selectPlaceholder": "Pilih jenis...",
      "values": {
        "externalMrn": "MRN Luaran",
        "insuranceId": "ID Insurans",
        "studyId": "ID Kajian",
        "healthCard": "Kad Kesihatan",
        "nationalRegistry": "Daftar Negara",
        "passport": "Pasport",
        "driverLicense": "Lesen Memandu",
        "other": "Lain-lain"
      }
    },
    "fields": {
      "value": "Nilai",
      "assigningAuthority": "Pihak Berkuasa Pengeluar",
      "effectiveDate": "Tarikh Berkuat Kuasa",
      "expiryDate": "Tarikh Tamat Tempoh"
    },
    "placeholders": {
      "value": "cth: 850101-14-5678",
      "assigningAuthority": "cth: KKM Malaysia"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Aktif",
        "inactive": "Tidak Aktif"
      }
    },
    "columns": {
      "type": "Jenis",
      "value": "Nilai",
      "assigningAuthority": "Pihak Berkuasa Pengeluar",
      "effectiveDate": "Tarikh Berkuat Kuasa",
      "expiryDate": "Tarikh Tamat Tempoh",
      "status": "Status",
      "actions": "Tindakan"
    },
    "save": "Simpan",
    "cancel": "Batal",
    "removeTooltip": "Buang pengecam",
    "addedSuccess": "Pengecam ditambah",
    "addError": "Gagal menambah pengecam",
    "removedSuccess": "Pengecam dibuang",
    "removeError": "Gagal membuang pengecam",
    "requiredError": "Jenis dan nilai diperlukan",
    "confirmRemoveTitle": "Buang Pengecam",
    "confirmRemoveMessage": "Adakah anda pasti mahu membuang \"{{type}}: {{value}}\"?",
    "confirmRemoveLabel": "Buang"
  },
  "pages": {
    "advanceDirectives": {
      "title": "Arahan Perubatan Awal",
      "addButton": "Tambah Arahan",
      "emptyState": "Tiada arahan perubatan awal direkodkan untuk pesakit ini.",
      "loading": "Memuatkan arahan perubatan awal...",
      "loadError": "Gagal memuatkan arahan perubatan awal.",
      "documentLink": "Lihat Dokumen",
      "effectivePrefix": "Berkuat kuasa:",
      "reviewPrefix": "Semakan:",
      "form": {
        "title": "Arahan Perubatan Awal Baharu",
        "labels": {
          "directiveType": "Jenis Arahan",
          "status": "Status",
          "effectiveDate": "Tarikh Berkuat Kuasa",
          "notes": "Nota",
          "optional": "pilihan"
        },
        "placeholders": {
          "notes": "Nota tambahan tentang arahan..."
        },
        "selectTypePlaceholder": "Pilih jenis...",
        "aria": {
          "effectiveDate": "Tarikh Berkuat Kuasa"
        },
        "buttons": {
          "save": "Simpan Arahan",
          "cancel": "Batal"
        }
      },
      "directiveType": {
        "DNR": "Jangan Resusitasi (DNR)",
        "living-will": "Wasiat Hidup",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "Wakil Penjagaan Kesihatan",
        "power-of-attorney": "Surat Kuasa Berkekalan"
      },
      "directiveStatus": {
        "active": "Aktif",
        "inactive": "Tidak Aktif",
        "revoked": "Dibatalkan",
        "pending": "Menunggu Semakan"
      },
      "toast": {
        "added": "Arahan perubatan awal ditambah",
        "addFailed": "Gagal menambah arahan perubatan awal",
        "directiveTypeRequired": "Jenis arahan diperlukan"
      }
    },
    "familyHistory": {
      "title": "Sejarah Keluarga",
      "addButton": "Tambah Entri",
      "emptyState": "Tiada sejarah keluarga direkodkan untuk pesakit ini.",
      "loading": "Memuatkan sejarah keluarga...",
      "loadError": "Gagal memuatkan sejarah keluarga.",
      "onsetAge": "Umur permulaan: {{age}} tahun",
      "outcomePrefix": "Hasil:",
      "form": {
        "title": "Entri Sejarah Keluarga Baharu",
        "labels": {
          "relationship": "Hubungan",
          "conditionName": "Nama Keadaan",
          "conditionCode": "Kod Keadaan",
          "onsetAge": "Umur Permulaan",
          "outcome": "Hasil",
          "optional": "pilihan"
        },
        "placeholders": {
          "onsetAge": "Umur dalam tahun"
        },
        "selectRelationshipPlaceholder": "Pilih hubungan...",
        "selectOutcomePlaceholder": "Pilih hasil...",
        "buttons": {
          "save": "Simpan Entri",
          "cancel": "Batal"
        }
      },
      "relationship": {
        "Mother": "Ibu",
        "Father": "Bapa",
        "Sibling": "Adik-beradik",
        "Maternal Grandmother": "Nenek (sebelah ibu)",
        "Maternal Grandfather": "Datuk (sebelah ibu)",
        "Paternal Grandmother": "Nenek (sebelah bapa)",
        "Paternal Grandfather": "Datuk (sebelah bapa)",
        "Child": "Anak",
        "Aunt": "Mak Cik",
        "Uncle": "Pak Cik"
      },
      "outcome": {
        "alive": "Hidup",
        "deceased": "Meninggal",
        "unknown": "Tidak Diketahui"
      },
      "toast": {
        "added": "Entri sejarah keluarga ditambah",
        "addFailed": "Gagal menambah entri sejarah keluarga",
        "relationshipAndConditionRequired": "Hubungan dan keadaan diperlukan"
      }
    },
    "socialHistory": {
      "title": "Sejarah Sosial",
      "editButton": "Sunting",
      "loading": "Memuatkan sejarah sosial...",
      "loadError": "Gagal memuatkan sejarah sosial.",
      "labels": {
        "smokingStatus": "Status Merokok",
        "alcoholUse": "Penggunaan Alkohol",
        "substanceUse": "Penggunaan Bahan",
        "housing": "Perumahan",
        "employment": "Pekerjaan",
        "safetyScreening": "Saringan Keselamatan",
        "notes": "Nota"
      },
      "placeholders": {
        "notes": "Nota tambahan..."
      },
      "buttons": {
        "save": "Simpan Perubahan",
        "cancel": "Batal"
      },
      "toast": {
        "updated": "Sejarah sosial dikemas kini",
        "updateFailed": "Gagal mengemas kini sejarah sosial"
      },
      "smokingStatus": {
        "never": "Tidak Pernah Merokok",
        "former": "Bekas Perokok",
        "currentDaily": "Perokok Harian Semasa",
        "currentOccasional": "Perokok Sekali-sekala Semasa",
        "unknown": "Tidak Diketahui"
      },
      "alcoholUse": {
        "None": "Tiada",
        "Social/Occasional": "Sosial/Sekali-sekala",
        "Moderate": "Sederhana",
        "Heavy": "Banyak",
        "In Recovery": "Dalam Pemulihan",
        "Unknown": "Tidak Diketahui"
      },
      "substanceUse": {
        "None": "Tiada",
        "Current Use": "Penggunaan Semasa",
        "Former Use": "Penggunaan Lampau",
        "In Treatment": "Dalam Rawatan",
        "Unknown": "Tidak Diketahui"
      },
      "housing": {
        "Stable": "Stabil",
        "Unstable": "Tidak Stabil",
        "Homeless": "Tiada Tempat Tinggal",
        "Assisted Living": "Kehidupan Berbantu",
        "Nursing Facility": "Kemudahan Jagaan",
        "Unknown": "Tidak Diketahui"
      },
      "employment": {
        "Employed Full-Time": "Bekerja Sepenuh Masa",
        "Employed Part-Time": "Bekerja Separuh Masa",
        "Self-Employed": "Bekerja Sendiri",
        "Unemployed": "Tidak Bekerja",
        "Retired": "Bersara",
        "Student": "Pelajar",
        "Disabled": "OKU Tidak Boleh Bekerja",
        "Unknown": "Tidak Diketahui"
      },
      "safetyScreening": {
        "No Concerns": "Tiada Kebimbangan",
        "Concerns Identified": "Kebimbangan Dikenal Pasti",
        "Declined to Answer": "Enggan Menjawab",
        "Not Screened": "Belum Disaring"
      }
    },
    "surgicalHistory": {
      "title": "Sejarah Pembedahan",
      "addButton": "Tambah Prosedur",
      "emptyState": "Tiada sejarah pembedahan didokumenkan untuk pesakit ini.",
      "loading": "Memuatkan sejarah pembedahan...",
      "loadError": "Gagal memuatkan sejarah pembedahan.",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "Tarikh: {{date}}",
      "surgeonLabel": "Pakar Bedah: {{name}}",
      "anesthesiaLabel": "Anestesia: {{type}}",
      "outcomePrefix": "Hasil:",
      "complicationsPrefix": "Komplikasi:",
      "form": {
        "title": "Entri Sejarah Pembedahan Baharu",
        "labels": {
          "procedureName": "Nama Prosedur",
          "procedureCode": "Kod Prosedur",
          "procedureCodeSuffix": "(CPT)",
          "date": "Tarikh",
          "surgeonName": "Nama Pakar Bedah",
          "anesthesiaType": "Jenis Anestesia",
          "laterality": "Bahagian",
          "outcome": "Hasil",
          "complications": "Komplikasi"
        },
        "placeholders": {
          "surgeonName": "Nama pakar bedah",
          "complications": "Komplikasi jika ada..."
        },
        "selectPlaceholder": "Pilih...",
        "aria": {
          "procedureDate": "Tarikh Prosedur"
        },
        "buttons": {
          "save": "Simpan Entri",
          "cancel": "Batal"
        }
      },
      "anesthesiaType": {
        "general": "Anestesia Umum",
        "regional": "Anestesia Serantau",
        "local": "Anestesia Tempatan",
        "spinal": "Anestesia Spina",
        "epidural": "Anestesia Epidural",
        "sedation": "Sedasi",
        "none": "Tiada",
        "unknown": "Tidak Diketahui"
      },
      "laterality": {
        "left": "Kiri",
        "right": "Kanan",
        "bilateral": "Bilateral"
      },
      "toast": {
        "added": "Entri sejarah pembedahan ditambah",
        "addFailed": "Gagal menambah entri sejarah pembedahan",
        "procedureNameRequired": "Nama prosedur diperlukan"
      }
    },
    "referralManagement": {
      "title": "Rujukan",
      "addButton": "Rujukan Baharu",
      "refresh": "Segar semula",
      "loading": "Memuatkan rujukan...",
      "errorState": "Gagal memuatkan rujukan.",
      "emptyState": "Tiada rujukan untuk pesakit ini.",
      "emptyStateFiltered": "Tiada rujukan yang sepadan dengan status dipilih.",
      "ariaFilterStatus": "Tapis rujukan mengikut status",
      "externalBadge": "Luaran",
      "filterStatus": {
        "allLabel": "Semua Status"
      },
      "table": {
        "type": "Jenis",
        "reason": "Sebab",
        "specialty": "Pakar",
        "priority": "Keutamaan",
        "status": "Status",
        "requested": "Diminta",
        "target": "Sasaran"
      },
      "form": {
        "title": "Rujukan Baharu",
        "labels": {
          "referralType": "Jenis Rujukan",
          "priority": "Keutamaan",
          "specialty": "Pakar",
          "reason": "Sebab",
          "targetDate": "Tarikh Sasaran",
          "clinicalNotes": "Nota Klinikal",
          "optional": "pilihan"
        },
        "placeholders": {
          "reason": "Sebab rujukan",
          "clinicalNotes": "Nota klinikal tambahan..."
        },
        "selectReferralTypePlaceholder": "Pilih jenis...",
        "selectSpecialtyPlaceholder": "Pilih bidang pakar...",
        "buttons": {
          "create": "Cipta Rujukan",
          "cancel": "Batal"
        }
      },
      "referralType": {
        "consultation": "Konsultasi",
        "transfer": "Pemindahan Penjagaan",
        "second-opinion": "Pendapat Kedua",
        "diagnostic": "Diagnostik",
        "therapeutic": "Terapeutik"
      },
      "priority": {
        "routine": "Rutin",
        "urgent": "Segera",
        "stat": "STAT"
      },
      "status": {
        "draft": "Draf",
        "submitted": "Dihantar",
        "accepted": "Diterima",
        "scheduled": "Dijadualkan",
        "completed": "Selesai",
        "cancelled": "Dibatalkan"
      },
      "toasts": {
        "createSuccess": "Rujukan dicipta",
        "createFailed": "Gagal mencipta rujukan",
        "validationFailed": "Jenis rujukan dan sebab diperlukan"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "{{count}} pasangan melibatkan pesakit yang anda tidak boleh lihat",
      "title_other": "{{count}} pasangan melibatkan pesakit yang anda tidak boleh lihat",
      "body": "Salah seorang pesakit anda mungkin pendua rekod di fasiliti lain. Pasangan itu tidak disenaraikan kerana menilainya bermakna melihat pesakit di luar capaian anda — minta Pengurusan Maklumat Kesihatan menyemaknya."
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "Eksport rekod",
    "exporting": "Mengeksport…",
    "success": "Rekod dieksport",
    "failed": "Eksport gagal — tiada apa-apa dimuat turun",
    "tooltip": "Muat turun rekod lengkap pesakit ini sebagai fail mudah alih"
  },
  "device": {
    "addTitle": "Rekod Peranti Implan",
    "editTitle": "Rekod Eksplan",
    "deviceName": "Nama peranti",
    "deviceNamePlaceholder": "cth., Evera MRI ICD, stent elusi ubat",
    "deviceNameTooLong": "Nama peranti mestilah 512 aksara atau kurang",
    "deviceType": "Jenis peranti",
    "deviceTypePlaceholder": "cth., perentak jantung, stent, prostesis",
    "udi": "UDI",
    "udiPlaceholder": "Pembawa Pengenalan Peranti Unik",
    "deviceCode": "Kod peranti",
    "deviceCodeSystem": "Sistem kod",
    "deviceCodeSystemPlaceholder": "cth., GMDN, SNOMED CT",
    "manufacturer": "Pengilang",
    "modelNumber": "Model",
    "lotNumber": "No. lot",
    "serialNumber": "No. siri",
    "implantDate": "Tarikh implan",
    "explantDate": "Tarikh eksplan",
    "status": "Status",
    "statusOptions": {
      "active": "Aktif",
      "inactive": "Tidak aktif",
      "explanted": "Dieksplan"
    },
    "mriSafety": "Keselamatan MRI",
    "mriSafetyOptions": {
      "safe": "Selamat",
      "conditional": "Bersyarat",
      "unsafe": "Tidak selamat",
      "unknown": "Tidak diketahui"
    },
    "notes": "Nota",
    "notesPlaceholder": "Nota tambahan...",
    "savedSuccess": "Peranti berjaya direkod",
    "saveError": "Gagal merekod peranti",
    "updatedSuccess": "Eksplan berjaya direkod",
    "updateError": "Gagal merekod eksplan",
    "explantRequiresDate": "Peranti yang dieksplan memerlukan tarikh eksplan",
    "explantBeforeImplant": "Tarikh eksplan tidak boleh sebelum tarikh implan"
  },
  "devices": {
    "pageTitle": "Peranti Implan",
    "addDevice": "Rekod Peranti",
    "loading": "Memuatkan peranti...",
    "loadError": "Gagal memuatkan maklumat peranti.",
    "empty": {
      "title": "Tiada Peranti Implan",
      "body": "Tiada peranti direkodkan untuk pesakit ini."
    },
    "sections": {
      "active": "Peranti Aktif ({{count}})",
      "history": "Dieksplan / Tidak Aktif ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "Pengilang",
      "implanted": "Diimplan",
      "explanted": "Dieksplan",
      "mriSafety": "Keselamatan MRI",
      "recorded": "Direkod"
    },
    "recordExplant": "Rekod eksplan",
    "explantTooltip": "Rekod pengeluaran peranti ini",
    "removeTooltip": "Alih keluar entri",
    "removedSuccess": "Entri peranti dialih keluar",
    "removeError": "Gagal mengalih keluar entri peranti",
    "confirmDeleteTitle": "Sahkan Pengalihan",
    "confirmDeleteMessage": "Alih keluar \"{{name}}\" daripada senarai? Alih keluar hanya entri yang direkod secara silap — untuk merekod pengeluaran dari badan, gunakan Rekod eksplan.",
    "confirmLabel": "Sahkan"
  },
  "ccdaImports": {
    "title": "Import C-CDA",
    "subtitle": "Dokumen diterima untuk rekonsiliasi. Buka import untuk menyemak setiap entri ke dalam carta.",
    "empty": "Tiada dokumen diimport untuk pesakit ini.",
    "loadError": "Tidak dapat memuatkan import.",
    "received": "Diterima",
    "docType": "Jenis",
    "status": "Status",
    "pending": "Belum selesai",
    "entries": "Entri",
    "match": "Padanan",
    "mismatch": "ID tidak padan",
    "statuses": {
      "pending": "Belum selesai",
      "reviewed": "Disemak",
      "dismissed": "Ditolak"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "Nota rujukan",
      "discharge-summary": "Ringkasan discaj",
      "other": "Lain-lain"
    }
  },
  "ccdaReview": {
    "title": "Import #{{id}}",
    "back": "Kembali ke import",
    "loadError": "Tidak dapat memuatkan import ini.",
    "mismatchWarning": "Pengecam pengirim tidak sepadan dengan pesakit ini. Sahkan dokumen ini miliknya sebelum menerima apa-apa.",
    "unnamed": "Entri tanpa nama",
    "accept": "Terima",
    "reject": "Tolak",
    "accepted": "Entri digabungkan ke dalam carta",
    "rejected": "Entri ditolak",
    "alreadyReviewed": "Telah disemak oleh orang lain — dikemas kini di bawah",
    "reviewError": "Semakan gagal",
    "confirmAcceptTitle": "Terima ke dalam carta?",
    "confirmAcceptMessage": "“{{name}}” akan ditambah ke dalam carta pesakit ini.",
    "confirmRejectTitle": "Tolak entri ini?",
    "confirmRejectMessage": "“{{name}}” akan digugurkan dari barisan. Dokumen mentah kekal difailkan.",
    "sections": {
      "problem": "Masalah",
      "medication": "Ubat-ubatan",
      "allergy": "Alahan"
    },
    "statuses": {
      "accepted": "Diterima",
      "rejected": "Ditolak"
    }
  }
}
